import * as React from "react";

export default function AiGeneratingRobot({
    className = "size-4",
}: {
    className?: string;
}) {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            className={`${className} motion-safe:animate-bounce motion-reduce:animate-none`}
        >
            <rect
                x="4"
                y="8"
                width="16"
                height="11"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.75"
            />
            <path
                d="M12 3v3M8 3h8"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
            />
            <circle cx="9" cy="13" r="1" fill="currentColor" />
            <circle cx="15" cy="13" r="1" fill="currentColor" />
            <path
                d="M9 16h6"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
            />
        </svg>
    );
}
